var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pr-2"},_vm._l((_vm.filtersForUi),function(filter){return _c(_vm.getFilterComponent(filter),{key:filter.name,tag:"component",attrs:{"filter":filter,"real-time":true,"values":filter.values}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }